import React, { useState, useEffect } from 'react';

const LocationSourceMessage = ({ locationSource, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show message for app default location
    if (locationSource === 'app_default' || locationSource === 'app_default_fallback') {
      setIsVisible(true);
      
      // Auto-hide after 10 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, 10000);
      
      return () => clearTimeout(timer);
    }
  }, [locationSource, onClose]);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      maxWidth: '350px',
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeaa7',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 1000,
      animation: 'slideIn 0.3s ease-out'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '8px'
      }}>
        <div style={{ fontWeight: '600', color: '#856404' }}>
          📍 Using Default Location
        </div>
        <button
          onClick={() => {
            setIsVisible(false);
            if (onClose) onClose();
          }}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            color: '#856404',
            padding: '0',
            marginLeft: '8px'
          }}
        >
          ×
        </button>
      </div>
      
      <div style={{ fontSize: '14px', color: '#856404', marginBottom: '12px' }}>
        The app is currently using New Delhi as your location. 
        You can customize this in your profile settings.
      </div>
      
      <div style={{ display: 'flex', gap: '8px' }}>
        <a
          href="/profile"
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '6px 12px',
            borderRadius: '4px',
            textDecoration: 'none',
            fontSize: '13px',
            fontWeight: '500'
          }}
        >
          Location Settings
        </a>
        <button
          onClick={() => {
            setIsVisible(false);
            if (onClose) onClose();
          }}
          style={{
            backgroundColor: 'transparent',
            color: '#856404',
            border: '1px solid #856404',
            padding: '6px 12px',
            borderRadius: '4px',
            fontSize: '13px',
            cursor: 'pointer'
          }}
        >
          Dismiss
        </button>
      </div>
      
      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default LocationSourceMessage;
